import { gql } from '@apollo/client';

const APP_CONTROL_FRAGMENT = `
  id
  key
  label
  description
  category
  valueType
  value
  isPublic
  created
  updated
`;

export const M_APP_CONTROLS = gql`
  mutation m_appControls($input: InputAppControlList!) {
    m_appControls(input: $input) {
      count
      rows {
        ${APP_CONTROL_FRAGMENT}
      }
    }
  }
`;

export const Q_APP_CONTROLS = gql`
  query appControls($input: InputAppControlList!) {
    appControls(input: $input) {
      count
      rows {
        ${APP_CONTROL_FRAGMENT}
      }
    }
  }
`;

export const Q_APP_CONTROL_PUBLIC = gql`
  query appControlPublic($input: InputAppControlByKey!) {
    appControlPublic(input: $input) {
      ${APP_CONTROL_FRAGMENT}
    }
  }
`;

export const M_APP_CONTROL_UPSERT = gql`
  mutation upsertAppControl($input: InputAppControlUpsert!) {
    upsertAppControl(input: $input) {
      message
    }
  }
`;

export const M_APP_CONTROL_DELETE = gql`
  mutation deleteAppControl($input: InputAppControlByKey!) {
    deleteAppControl(input: $input) {
      message
    }
  }
`;

